import React from 'react';

const DaySummary = () => {
  const days = [
    { day: 'Monday', minutes: 420 },
    { day: 'Wednesday', minutes: 360 },
    { day: 'Sunday', minutes: 180 },
  ];

  return (
    <div className="card">
      <h2>Popular & Least Popular Day of the Week</h2>
      <div className="day-summary">
        <h3>Most Popular Day</h3>
        <p>{days[0].day}: {days[0].minutes} minutes</p>
        <h3>Least Popular Day</h3>
        <p>{days[2].day}: {days[2].minutes} minutes</p>
      </div>
    </div>
  );
};

export default DaySummary;
